/* Popular Resources */
import styled from 'styled-components';

export const PopularWrapper = styled.div`
.resources {
    text-align: center;
    padding: 10px;
}

.resources h5 {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
}

.resources-img {
    width: 80px;
    height: 80px;
}

.popular-sec .card-body h5 {
    font-size: 16px;
}`;